/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Ai_Tailored_DescInputs */

const en_landing_feature_ai_tailored_desc = /** @type {(inputs: Landing_Feature_Ai_Tailored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume is uniquely crafted by Mistral AI to match the specific job description. Not templates — truly personalized content that highlights your most relevant experience.`)
};

const de_landing_feature_ai_tailored_desc = /** @type {(inputs: Landing_Feature_Ai_Tailored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Lebenslauf wird von Mistral-KI individuell auf die jeweilige Stellenausschreibung zugeschnitten. Keine Vorlagen -- wirklich personalisierte Inhalte, die Ihre relevanteste Erfahrung hervorheben.`)
};

const fr_landing_feature_ai_tailored_desc = /** @type {(inputs: Landing_Feature_Ai_Tailored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque CV est uniquement elabore par Mistral AI pour correspondre a loffre demploi. Pas de modeles -- un contenu vraiment personnalise qui met en valeur votre experience la plus pertinente.`)
};

const es_landing_feature_ai_tailored_desc = /** @type {(inputs: Landing_Feature_Ai_Tailored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada CV es creado de forma unica por Mistral AI para coincidir con la oferta de trabajo. No son plantillas -- contenido verdaderamente personalizado que destaca tu experiencia mas relevante.`)
};

const it_landing_feature_ai_tailored_desc = /** @type {(inputs: Landing_Feature_Ai_Tailored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni CV viene creato in modo unico da Mistral AI per corrispondere alla specifica offerta di lavoro. Non modelli -- contenuto veramente personalizzato che evidenzia la tua esperienza piu rilevante.`)
};

const nl_landing_feature_ai_tailored_desc = /** @type {(inputs: Landing_Feature_Ai_Tailored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elk CV wordt uniek opgesteld door Mistral AI om te passen bij de specifieke vacature. Geen sjablonen -- echt gepersonaliseerde inhoud die uw meest relevante ervaring benadrukt.`)
};

const pl_landing_feature_ai_tailored_desc = /** @type {(inputs: Landing_Feature_Ai_Tailored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kazde CV jest unikatowo tworzone przez Mistral AI, aby pasowalo do konkretnego ogloszenia o prace. Nie szablony -- prawdziwie spersonalizowana tresc, ktora podkresla Twoje najwazniejsze doswiadczenie.`)
};

const fi_landing_feature_ai_tailored_desc = /** @type {(inputs: Landing_Feature_Ai_Tailored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokainen ansioluettelo on Mistral AI:n ainutlaatuisesti raataloima vastaamaan tiettyae tyopaikkailmoitusta. Ei malleja -- aidosti personoitua sisaltoa, joka korostaa merkityksellisintae kokemustasi.`)
};

const da_landing_feature_ai_tailored_desc = /** @type {(inputs: Landing_Feature_Ai_Tailored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvert CV er unikt tilpasset af Mistral AI til den specifikke jobopslag. Ikke skabeloner -- virkelig personaliseret indhold, der fremhaever din mest relevante erfaring.`)
};

const sv_landing_feature_ai_tailored_desc = /** @type {(inputs: Landing_Feature_Ai_Tailored_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varje CV skapas unikt av Mistral AI foer att matcha den specifika jobbannonsens. Inga mallar -- verkligt personaliserat innehaall som framhaever din mest relevanta erfarenhet.`)
};

/**
* | output |
* | --- |
* | "Each resume is uniquely crafted by Mistral AI to match the specific job description. Not templates — truly personalized content that highlights your most rel..." |
*
* @param {Landing_Feature_Ai_Tailored_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_ai_tailored_desc = /** @type {((inputs?: Landing_Feature_Ai_Tailored_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Ai_Tailored_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_ai_tailored_desc(inputs)
	if (locale === "fr") return fr_landing_feature_ai_tailored_desc(inputs)
	if (locale === "es") return es_landing_feature_ai_tailored_desc(inputs)
	if (locale === "it") return it_landing_feature_ai_tailored_desc(inputs)
	if (locale === "nl") return nl_landing_feature_ai_tailored_desc(inputs)
	if (locale === "pl") return pl_landing_feature_ai_tailored_desc(inputs)
	if (locale === "fi") return fi_landing_feature_ai_tailored_desc(inputs)
	if (locale === "da") return da_landing_feature_ai_tailored_desc(inputs)
	if (locale === "sv") return sv_landing_feature_ai_tailored_desc(inputs)
	return en_landing_feature_ai_tailored_desc(inputs)
});